import { render, staticRenderFns } from "./SmsConfigTwilio.vue?vue&type=template&id=74576a17&"
import script from "./SmsConfigTwilio.vue?vue&type=script&lang=js&"
export * from "./SmsConfigTwilio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports